import React from 'react';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';
import { OpenSeaIcon } from 'icons/opensea';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import styles from './CollectionCard.module.scss';
import { Link } from 'react-router-dom';

export type CollectionCardProps = {
  name: string;
  description: string;
  imgs: readonly [string, string, string];
  size: number;
  openSeaLink: string;
  galleryLink: string;
};

export const CollectionCard = ({
  name,
  description,
  imgs,
  size,
  openSeaLink,
  galleryLink,
}: CollectionCardProps) => {
  return (
    <div className={styles.collectionCard}>
      <div>
        <div className={styles.imgContainer}>
          <LazyLoadImage className={styles.mainImg} src={imgs[0]} />
          <div className={styles.sideImgContainer}>
            <LazyLoadImage className={styles.sideImg} src={imgs[1]} />
            <LazyLoadImage className={styles.sideImg} src={imgs[2]} />
          </div>
        </div>
        <div className={styles.collectionDescription}>
          <h3>{name}</h3>
          <p>{description}</p>
        </div>
      </div>
      <div>
        <HorizontalDivider />
        <div className={styles.cardfooter}>
          <span>{size.toLocaleString()} ITEMS</span>
          <div className={styles.cardActions}>
            <a href={openSeaLink} target="_blank" rel="noreferrer">
              <div className={styles.openSeaIcon}>
                <OpenSeaIcon />
              </div>
            </a>
            <Link to={galleryLink}>
              <button className="btn btn-sm btn-primary">View</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
